import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useEffect, useRef, useState } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import UserOnglet from "../../user/UserOnglet";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicSinscrireCompetition = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Rechercher et s'inscrire", link: '/topics/rechercher'},
    { label: "S'inscrire des compétitions", link: '/topics/rechercher/sincrire-competition-index'},
    { label: topic.title, link: topic.link},
  ]

// <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/competitions`}>des compétitions</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Bienvenue sur Wodzone ! Vous pouvez dès à présent Woder où vous le souhaitez, mais d'abord, découvrez quelques conseils qui pourront vous être utiles.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                Il est tentant de se lancer directement dans la recherche, mais chaque chose en son temps : complétez d'abord votre profil. 
                Ce n'est pas obligatoire, mais un confort certain pour vos prochaines inscriptions. 
                Toutes ces informations seront pré-rempli pour vous par la suite.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <p className="help-text">
                Chercher une compétition, c'est presque aussi amusant que d'y être, non ? 
                Des centaines de compétitions uniques s'offrent à vous, partout en France. Vous trouverez forcément celle qui a tout pour vous faire passer 
                un moment intense et inoubliable.
              </p>
              <p className="help-text">
                Lorsque vous<a target='_blank' className="link" href={`/topics/inscription/26`}>recherchez un compétition,</a> 
                vous avez la possibilité de<a target='_blank' className="link" href={`/topics/inscription/27`}>filtrer</a>précisément 
                votre recherche ou de parcourir la liste librement. Pour chaque événement, prenez le temps d’examiner attentivement les rubriques suivantes :
              </p>
              <ul>
                <li className="pl-8 mb-8"><p className="help-text">Description</p></li>
                <li className="pl-8 mb-8"><p className="help-text">Les catégories et les standards</p></li>
                <li className="pl-8 mb-8"><p className="help-text">Règlement intérieur et conditions générales</p></li>
                <li className="pl-8 mb-8"><p className="help-text">Conditions d'annulation si présentes</p></li>
              </ul>
              <p className="help-text">
                N'hésitez pas à envoyer un message à l'organisateur via les réseaux pour toute question supplémentaire. 
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part">{anchorsParts[2].content}</p>
              <p className="help-text">
                À la suite de la description de la compétition, vous trouverez les différentes catégories dans lesquelles vous pouvez concourir.
                Chaque catégorie affiche son nom, son prix et le nombre de places encore disponibles. En cliquant sur une catégorie, vous accéderez aux détails 
                des standards attendus pour y participer.
              </p>
              <p className="help-text"> une catégorie n’a plus de places disponibles, elle sera désactivée et affichera le statut "Sold Out".
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[3].ref}>
              <p className="help-title-part">{anchorsParts[3].content}</p>
              <p className="help-text">
                En fonction de la<a target='_blank' className="link" href={`/topics/inscription/29`}>billeterie,</a> si celle-ci le permet,
                poursuivez en cliquant sur le bouton <strong>s'inscrire.</strong>
              </p>
              <p className="help-text mb-0"><strong>Etape 1 :</strong></p>
              <ul className="mt-4 mb-24">
                <li className="pl-8 mb-8"><p className="help-text">Choisissez alors une catégorie si ce n'est pas déjà fait. </p></li>
                <li className="pl-8 mb-8">
                  <p className="help-text">
                    Pour continuer, vous devez disposer d’un compte Wodzone et être connecté.
                    Si vous n’avez pas encore de compte ou si vous n’êtes pas connecté, saisissez votre adresse e-mail et laissez-vous guider par la procédure.
                  </p>
                </li>
                <li className="pl-8 mb-8"><p className="help-text">Une fois connecté, cliquez sur poursuivre l'inscription</p></li>
              </ul>              
              <p className="help-text mb-0"><strong>Etape 2 :</strong></p>
              <ul className="mt-4 mb-24">
                <li className="pl-8 mb-8">
                  <p className="help-text">Choisissez un nom d'équipe s'il s'agit d'une compétition à plusieurs.</p>
                </li>
                <li className="pl-8 mb-8">
                  <p className="help-text">Complétez vos informations personnelles manquantes s'il y en a.</p>
                </li>
                <li className="pl-8 mb-8">
                  <p className="help-text">
                    Saisissez le nom de vos coéquipiers s’ils ont déjà créé leur compte Wodzone. <br />
                    Sinon, pas de problème ! Cliquez sur "Cet athlète n'est pas présent ?" puis complétez les informations personnelles de cet athlète.
                  </p>
                </li>
              </ul>              
              <p className="help-text mb-0"><strong>Etape 3 :</strong></p>
              <ul className="mt-4 mb-24">
                <li className="pl-8 mb-8">
                  <p className="help-text">Saisissez votre moyen de paiement si inscription payante.</p>
                </li>
                <li className="pl-8 mb-8">
                  <p className="help-text">Lisez bien les conditions générales et le détails de votre commande.</p>
                </li>
                <li className="pl-8 mb-8">
                  <p className="help-text">
                    Si tout est correct, cliquez sur "Confirmer et payer". Vous serez ensuite redirigé vers une page de confirmation.
                    Tous les participants recevront un e-mail confirmant votre inscription.
                  </p>
                </li>
              </ul>              
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicSinscrireCompetition